import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import type React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Catch from '@/lib/functionalErrorBoundary';
import { useLogger } from '@/lib/hooks/useLogger';

import { Nav } from './Nav';
import { Page } from './Page';

type Props = {
    children: React.ReactNode;
};

const ErrorDisplay = styled.div`
    padding: 20px;
`;

const ErrorPage = () => {
    const { t } = useTranslation();
    const log = useLogger({ component: 'ErrorPage' });
    const handleReload = useCallback(() => {
        log.userAction('handleReload', 'clicked');
        window.location.reload();
    }, [log]);

    return (
        <>
            <Nav showMenu={false} />
            <Page>
                <ErrorDisplay>
                    <h2>{t('error_boundary.title', 'A network error has occurred')}</h2>
                    <p> {t('error_boundary.help_text', 'Try reloading the page to continue')}</p>
                    <Button variant="contained" onClick={handleReload}>
                        {t('error_boundary.button_reload', 'Reload')}
                    </Button>
                </ErrorDisplay>
            </Page>
        </>
    );
};

export const ErrorBoundary = Catch(function ErrorBoundary({ children }: Props, error?: Error) {
    if (error) {
        return <ErrorPage />;
    }
    return <>{children}</>;
});
